import { Scope } from '../enums/scope'
import { isAuthorized } from '../utils/isAuthorized'

export const useIsHelpCenterEnabled = () => {
  const isHelpCenterEnabled = isAuthorized([Scope.HelpCenterWrite])

  return { isHelpCenterEnabled }
}
